document.addEventListener('DOMContentLoaded', function () {
  // Homepage video image banner section video play puash
  document.querySelectorAll('.block__Video-image-banner-section-slideshow .slideshow__slide.grid__item')
    .forEach(container => {
    const parentSection = container.closest('.block__Video-image-banner-section-slideshow');
    if (!parentSection) return;

    const video = container.querySelector('.block__banner-video');
    const playPauseBtn = container.querySelector('.play-pause-btn');
    const muteBtn = container.querySelector('.mute-btn');
    const playIcon = playPauseBtn?.querySelector('.play-icon');
    const pauseIcon = playPauseBtn?.querySelector('.pause-icon');
    const muteIcon = muteBtn?.querySelector('.play-mute');
    const unmuteIcon = muteBtn?.querySelector('.play-unmute');

    if (!video || !playPauseBtn || !muteBtn) return;

    const updateIcons = () => {
      if (video.paused) {
        playIcon?.classList.add('icon-visible');
        pauseIcon?.classList.remove('icon-visible');
      } else {
        playIcon?.classList.remove('icon-visible');
        pauseIcon?.classList.add('icon-visible');
      }

      if (video.muted) {
        muteIcon?.classList.add('icon-visible');
        unmuteIcon?.classList.remove('icon-visible');
      } else {
        muteIcon?.classList.remove('icon-visible');
        unmuteIcon?.classList.add('icon-visible');
      }
    };

    video.pause();
    video.muted = true;
    updateIcons();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            video.play().catch(err => console.log('Autoplay failed:', err));
            playIcon?.classList.remove('icon-visible');
            pauseIcon?.classList.add('icon-visible');
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.5
      }
    );
    setTimeout(function(){
      observer.observe(video);
    },2000)

    playPauseBtn.addEventListener('click', () => {
      video.paused ? video.play() : video.pause();
      updateIcons();
    });

    muteBtn.addEventListener('click', () => {
      video.muted = !video.muted;
      updateIcons();
    });

    video.addEventListener('ended', updateIcons);
  });

  // Megamenu Video play push
  document.querySelectorAll('.block__mega-menu_poster-imgandvideo .block__mega-menu_poster_image .play-icon').forEach((playButton) => {
    playButton.addEventListener('click', (event) => {
      const container = event.currentTarget.closest('.block__mega-menu_poster_image');
      container.querySelector('.pause-icon').classList.remove('play-video');
      playButton.classList.add('play-video');
      const video = container.querySelector('video');
      if (video) video.play();
    });
  });
  document.querySelectorAll('.block__mega-menu_poster-imgandvideo .block__mega-menu_poster_image .pause-icon').forEach((pauseIcon) => {
    pauseIcon.addEventListener('click', () => {
      const container = pauseIcon.closest('.block__mega-menu_poster_image');
      const video = container.querySelector('video');
      if (video) video.pause();
      container.querySelector('.play-icon').classList.remove('play-video');
      pauseIcon.classList.add('play-video');
    });
  });

});



document.addEventListener('DOMContentLoaded', function() {
  // Dropdown Footer menu on mobile
  if(window.screen.availWidth < 749 ){
    document.querySelectorAll('.footer-block--menu .footer-block__heading').forEach((footer_menu) => {
      footer_menu.addEventListener("click", OnClickMenuOpen);
    });

    function OnClickMenuOpen(event){
      var __this = event.currentTarget;
      if(__this.closest('.footer-block--menu').classList.contains('open')){
        __this.closest('.footer-block--menu').classList.remove('open');
      } else {
        var remove_class = __this.closest('.footer__blocks-wrapper').querySelectorAll('.footer-block--menu');
      remove_class.forEach(el=>el.classList.remove('open'));
      __this.closest('.footer-block--menu').classList.add('open');
      }
    }
  }
// section video play and pause
  document.querySelectorAll('.block__image-with-video-inner--video-img .play-button').forEach((play_button) => {
    play_button.addEventListener('click', (event) => {
      var __this = event.currentTarget;
      __this.classList.add('play-video');
      __this.closest('.block__image-with-video-inner--video-img').querySelector('video').play();
    });
  });
  
  document.querySelectorAll('.block__image-grid--video .play-button').forEach((play_button) => {
    play_button.addEventListener('click', (event) => {
      var __this = event.currentTarget;
      __this.classList.add('play-video');
      __this.closest('.block__image-grid--video').querySelector('video').play();
    });
  });
    const review_product = document.querySelectorAll('.block_review-product-slider--products.swiper')
    review_product && review_product.forEach(review_w_product => {
    new Swiper(review_w_product, {
        spaceBetween: 20,
        loop: true,
        navigation: {
        nextEl: '.block_review-product-slider-arrow-right',
        prevEl: '.block_review-product-slider-arrow-left',
        },
        breakpoints: {
        310: {
            slidesPerView: 1.2,
            spaceBetween: 10,
            loop: true
        },
        750: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 20
        }
        }
    });
    });
    const enhance_product = document.querySelectorAll('.block__enhance-products-slider.swiper')
    enhance_product && enhance_product.forEach(enhance_widget => {
      new Swiper(enhance_widget, {
          spaceBetween: 12,
          loop: true,
          navigation: {
          nextEl: '.block__enhance-products-slider-arrow-right',
          prevEl: '.block__enhance-products-slider-arrow-left',
          },
          breakpoints: {
          310: {
              slidesPerView: 1.8,
              spaceBetween: 12,
          },
          750: {
              slidesPerView: 2.25,
              spaceBetween: 12,
          },
          1200: {
              slidesPerView: 3.25,
              spaceBetween: 12,
          }
          }
      });
    });
    const you_may_also_like_products = document.querySelectorAll('.block__you-may-also-like-products-slider.swiper');
    if(you_may_also_like_products.length > 0) {
      you_may_also_like_products && you_may_also_like_products.forEach(drawer_upsell => {
        new Swiper(drawer_upsell, {
          spaceBetween: 12,
          loop: true,
          navigation: {
          nextEl: '.block__you-may-also-like-products-slider-arrow-right',
          prevEl: '.block__you-may-also-like-products-slider-arrow-left',
          },
          breakpoints: {
          310: {
              slidesPerView: 1.4,
              spaceBetween: 12,
              loop: true
          },
          610: {
              slidesPerView: 2.4,
              spaceBetween: 12
          }
          }
        });
      });
    }
    // Trending Blogs Slider Js Only Desktop Slider
if (window.matchMedia("(min-width: 768px)").matches) {
    const trending_blog = document.querySelectorAll('.block__trending_blog_desktop_slider_col.swiper');

    if (trending_blog.length > 0) {
        trending_blog.forEach(blog_slider_desktop => {
            new Swiper(blog_slider_desktop, {
                spaceBetween: 12,
                loop: true,
                navigation: {
                    nextEl: '.block__trendng_blog_slider_arrow_wrapper_right',
                    prevEl: '.block__trendng_blog_slider_arrow_wrapper_left',
                },
                breakpoints: {
                    310: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                        loop: true
                    },
                    750: {
                        slidesPerView: 2,
                        spaceBetween: 16
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 22
                    }
                }
            });
        });
    }
}

// Desktop & Mobile Js Trending Blogs Section
  const trending_blog_desktop_mobile = document.querySelectorAll('.block__trending_desktop_mobile_slider_col.swiper');

  if (trending_blog_desktop_mobile.length > 0) {
    trending_blog_desktop_mobile.forEach(blog_slider => {
          new Swiper(blog_slider, {
              spaceBetween: 12,
              loop: true,
              navigation: {
                  nextEl: '.block__trendng_blog_slider_arrow_wrapper_right',
                  prevEl: '.block__trendng_blog_slider_arrow_wrapper_left',
              },
              breakpoints: {
                  310: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                      loop: true
                  },
                  750: {
                      slidesPerView: 2,
                      spaceBetween: 16
                  },
                  1200: {
                      slidesPerView: 3,
                      spaceBetween: 22
                  }
              }
          });
      });
  }
    document.querySelectorAll('.block__title-and-video--yt-video .play-button').forEach((play_button) => {
      play_button.addEventListener('click', (event) => {
        var __this = event.currentTarget;
        __this.classList.add('play-video');
        __this.closest('.block__title-and-video--yt-video').querySelector('video').play();
      });
    });

});





// Menu-drawer Accordian mobile menu
document.querySelectorAll('.block__menu-drawer-acc-head').forEach(function (head) {
  head.addEventListener('click', function () {
    const isActive = this.classList.contains('active');
    const allHeads = document.querySelectorAll('.block__menu-drawer-acc-head');
    const allContents = document.querySelectorAll('.block__menu-drawer-content');

    allContents.forEach(function (content) {
      content.style.display = 'none';
    });

    allHeads.forEach(function (head) {
      head.classList.remove('active');
    });

    if (!isActive) {
      const siblingContent = this.nextElementSibling;
      if (siblingContent && siblingContent.classList.contains('block__menu-drawer-content')) {
        siblingContent.style.display = 'block';
      }
      this.classList.add('active');
    }
  });
});


// Event listener for mouseenter on mega menu navigation items
document.querySelectorAll('ul.block__mega-menu-nav-block li').forEach(function (menuItem) {
  menuItem.addEventListener('mouseenter', function () {
    var tabId = this.getAttribute('data-tab');
    var megaMenuContent = this.closest('.mega-menu__content');

    megaMenuContent.querySelectorAll('ul.block__mega-menu-nav-block li').forEach(function (li) {
      li.classList.remove('current');
    });

    megaMenuContent.querySelectorAll('.block__mega-menu-name').forEach(function (name) {
      name.classList.remove('current');
    });

    this.classList.add('current');
    var tabContent = document.getElementById(tabId);
    if (tabContent) {
      tabContent.classList.add('current');
    }
  });
});

// On hover, open header mega menu desktop

document.querySelectorAll('[id^="Details-"].mega-menu').forEach((hover_menu) => {
  const summaryLink = hover_menu.querySelector('summary a');
  const linkHref = summaryLink?.getAttribute('href');


  hover_menu.addEventListener("mouseenter", MouseEnter_event);
  hover_menu.addEventListener("mouseleave", MouseLeave_event);
  const overlay = hover_menu.querySelector('.block__mega-menu-overlay');
  if (overlay) {
    overlay.addEventListener('mouseenter', function () {
      document.body.classList.add('block__mega-menu-open');
      hover_menu.setAttribute('open', 'open');
    });

    overlay.addEventListener('mouseleave', function () {
      document.body.classList.remove('block__mega-menu-open');
      hover_menu.removeAttribute('open');
    });
  }
  if (summaryLink && linkHref) {
    summaryLink.addEventListener('click', function (e) {
      // e.preventDefault();  
      // e.stopPropagation();     
      // console.log(linkHref, 'linkHref'); 
      window.location.href = linkHref;   
    });
  }

});

function MouseEnter_event(event) {
  const __this = event.currentTarget;
  __this.querySelector('summary').setAttribute('aria-expanded', true);
  __this.setAttribute('open', 'open');
  document.body.classList.add('block__mega-menu-open');
}

function MouseLeave_event(event) {
  const __this = event.currentTarget;
  __this.querySelector('summary').setAttribute('aria-expanded', false);
  __this.removeAttribute('open', 'open');
  document.body.classList.remove('block__mega-menu-open');
}

function Menu_close_event(event) {
  const __this = event.currentTarget;
  const megaMenu = __this.closest('details.mega-menu');
  if (megaMenu) {
    megaMenu.querySelector('summary').setAttribute('aria-expanded', false);
    megaMenu.removeAttribute('open', 'open');
    document.body.classList.remove('block__mega-menu-open');
  }
}

function MouseEnter_submenuEvent(event) {
  var __this = event.currentTarget;
  var menu_name = __this.getAttribute('data-title');
  var remove_class = __this.closest('.mega-menu__content').querySelectorAll('.mega-menu__link.nav-active');
  remove_class.forEach(el=>el.classList.remove('nav-active'));
  __this.classList.add('nav-active');

  var remove_class2 = __this.closest('.mega-menu__content').querySelectorAll('.block__mega-child-links-with-banner');
  remove_class2.forEach(el=>el.classList.remove('active'));
  if(__this.closest('.mega-menu__content').querySelector(`[data-submenu-title="${menu_name}"]`) != null){
    __this.closest('.mega-menu__content').querySelector(`[data-submenu-title="${menu_name}"]`).classList.add('active');
  }
}

document.querySelectorAll('.mega-menu__link--level-2').forEach((hover_submenu) => {
  hover_submenu.addEventListener("mouseenter", MouseEnter_submenuEvent);
});


document.addEventListener("change", function(event) {
  if (event.target.matches(".block_main-subscription-options input[type=radio]")) {
      const radio = event.target;
      if (radio.checked && radio.value === "subscribe") {
          let handleSelectChange = function() {
              const selectedValue = select.value;
              subscriptionVal && (subscriptionVal.value = selectedValue);
              if(selectedValue != '') {
                  select.closest('.block_product-subscribe_multiple').classList.remove('show-subscription');
              }
          };
          radio.closest(".block_main-subscription-radio-options").querySelectorAll('.block_main-product-subscribe_drawer').forEach(subscription_select => {
            subscription_select.classList.add('option-active');
          });
          const select = radio.closest(".block_main-subscription-radio-options").querySelector(".block_main-product-subscribe_drawer select"),
              getInputVal = select ? select.value : null,
              subscriptionVal = radio.closest("product-info").querySelector(".block_main-form-input-selling-plan");
              subscriptionVal && (subscriptionVal.value = getInputVal), select.removeEventListener("change", handleSelectChange), select.addEventListener("change", handleSelectChange)
      } else {
          const getInputVal = radio.value,
          subscriptionVal = radio.closest("product-info").querySelector(".block_main-form-input-selling-plan");
          subscriptionVal && (subscriptionVal.value = getInputVal);
          radio.closest(".block_main-subscription-radio-options").querySelectorAll('.block_main-product-subscribe_drawer').forEach(subscription_select => {
            subscription_select.classList.remove('option-active');
          });
      }
      const priceElement = radio.closest(".block_main-product-subscribe_opt").querySelector(".block_main-subscribe-reg-price"),
            compare_priceElement = radio.closest(".block_main-product-subscribe_opt").querySelector(".block_main-subscribe-compare-price"),
            getPrice = priceElement ? priceElement.getAttribute("data-price") : null,
            getComparePrice = compare_priceElement ? compare_priceElement.getAttribute("data-com-price") : null,
            price = radio.closest("product-info").querySelector(".price__regular .price-item--regular"),
            price2 = radio.closest("product-info").querySelector(".price__sale .price-item--sale"),
            compare_price = radio.closest("product-info").querySelector(".price__sale .price-item--regular"),
            btn_price = radio.closest("product-info").querySelector(".product-form-with-qty-input .price_regulerr");

            if(price != null) {
              price.innerHTML = getPrice;
            }
            if(price2 != null) {
              price2.innerHTML = getPrice;
            }
            if(compare_price != null) {
              compare_price.innerHTML = getComparePrice;
            }
            if(btn_price != null) {
              btn_price.innerHTML = getPrice;
            }

      radio.closest(".block_main-subscription-options").querySelectorAll('.block_main-product-subscribe_opt').forEach(input_checked => {
          input_checked.classList.remove('active');
      });
      radio.closest(".block_main-product-subscribe_opt").classList.add('active');
  }
});

  // Faq  accordation
  document.querySelectorAll('.block__faq__question').forEach(tab => {
    tab.addEventListener("click", (event) => {
        event.preventDefault();
        let innerContent = event.currentTarget.closest('.block__faq--innercontent');
        if (!innerContent) return; 
        document.querySelectorAll('.block__faq--innercontent.faq-is-active')
        .forEach(el => el !== innerContent && el.classList.remove('faq-is-active'));
        innerContent.classList.toggle('faq-is-active');
    });
});

// start on click open tab faq on faqs  page

document.querySelectorAll('.block__faq-accordion-faq-title').forEach((tabFaq) => {
  tabFaq.addEventListener("click", (event) => {
    event.preventDefault();
    let wrapper = event.currentTarget.closest('.block__faq-accordion-faq-with-content-wrapper');
    let mainContainer = event.currentTarget.closest('.block__section-faq-accordion-content-info');

    if (!wrapper || !mainContainer) return; 

    let allWrappers = mainContainer.querySelectorAll('.block__faq-accordion-faq-with-content-wrapper');
    allWrappers.forEach(el => el.classList.remove('faq-accordion-faq-active'));

    wrapper.classList.toggle('faq-accordion-faq-active'); 
  });
});


window.addEventListener("load", function () {
  document.body.classList.add("active");
  document.querySelectorAll(".block__section-faq-accordion-links-inner p a").forEach(function (link) {
      let parentElement = link.closest(".block__section-faq-accordion-links");
      if (parentElement) {
          let pageUrl = parentElement.getAttribute("data-href");
          document.querySelectorAll(`.block__section-faq-accordion-links-inner p a[href="${pageUrl}"]`).forEach(function (matchingLink) {
              matchingLink.classList.add("active");
          });
      }
  });
});

// Mobile popup in faq-accordion

document.addEventListener("DOMContentLoaded", function () {
  let currentTab = document.querySelector(".faq_current_tab");
  if (currentTab) {  // Ensure the element exists before setting textContent
      let storedTab = localStorage.getItem("selectedTab");
      if (storedTab) {
          currentTab.textContent = storedTab;
      }
  }
  let faqLinks = document.querySelectorAll(".block__section-Faqs-How-May-We-Help-You-Today-grid-icon-with-text-with-bg a");
  faqLinks.forEach(link => {
      link.addEventListener("click", function (event) {
          event.preventDefault();
          let selectedText = this.querySelector(".block__section-Faqs-How-May-We-Help-You-Today-grid-icon-with-text--title")?.textContent.trim();
          if (selectedText) {
              localStorage.setItem("selectedTab", selectedText);
              if (currentTab) {
                  currentTab.textContent = selectedText;
              }
          }
          window.location.href = this.href;
      });
  });
});


document.addEventListener("DOMContentLoaded", function () {
    let toggle = document.querySelector(".block__section-faq-accordion-mobileaccordion");
    let dropdown = document.querySelector(".block__section-faq-accordion-dropdown");
    let currentTab = document.querySelector(".faq_current_tab");
    let links = document.querySelectorAll(".block__section-faq-accordion-links-inner a");

    let storedTab = localStorage.getItem("selectedTab");
    let defaultTab = storedTab || document.querySelector(".block__section-faq-accordion-links-inner a.active")?.textContent || "Select a tab";
    if(currentTab != null) {
      currentTab.textContent = defaultTab;
    }
    if(toggle != null) {
      toggle.addEventListener("click", function () {
          dropdown.classList.toggle("active");
      });
    }

    links.forEach(link => {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            let selectedText = this.textContent;

            currentTab.textContent = selectedText; 
            localStorage.setItem("selectedTab", selectedText); 
            dropdown.classList.remove("active"); 

            window.location.href = this.href; 
        });
    });
});

window.addEventListener("load", function () {
    document.body.classList.add("active");

    document.querySelectorAll(".block__section-faq-accordion-links-inner p a").forEach(function (link) {
        let parentElement = link.closest(".block__section-faq-accordion-links");
        if (parentElement) {
            let pageUrl = parentElement.getAttribute("data-href");
            document.querySelectorAll(`.block__section-faq-accordion-links-inner p a[href="${pageUrl}"]`).forEach(function (matchingLink) {
                matchingLink.classList.add("active");
                let currentTab = document.querySelector(".faq_current_tab");
                if (currentTab) {
                    currentTab.textContent = matchingLink.textContent;
                }
            });
        }
    });
});
// end on click open tab faq on faq page


// start on click open tab faq accorin  on support page
document.querySelectorAll('.block__Support-faq-title').forEach((tabFaq) => {
  tabFaq.addEventListener("click", (event) => {
    event.preventDefault();
    let wrapper = event.currentTarget.closest('.block__Support-faq-with-content-wrapper');
    let mainContainer = event.currentTarget.closest('.block__Support-faq-with-content--main');

    if (!wrapper || !mainContainer) return; 
    let allWrappers = mainContainer.querySelectorAll('.block__Support-faq-with-content-wrapper');
    allWrappers.forEach(el => el.classList.remove('support-faq-active'));
    wrapper.classList.toggle('support-faq-active'); 
  });
});
// end on click open tab faq accorin on support page


// start on wifi marketing  video tab open
document.addEventListener("DOMContentLoaded", function () {
  let tabs = document.querySelectorAll(".block__section_wifi-marketing-video-tab-title");
  let contents = document.querySelectorAll(".block__section_wifi-marketing-video-tab-content_video-tab");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      let targetTab = this.getAttribute("data-tab");

      tabs.forEach(btn => btn.classList.remove("active"));
      contents.forEach(content => content.classList.remove("active"));

      this.classList.add("active");
      document.querySelector(`.block__section_wifi-marketing-video-tab-content_video-tab.${targetTab}`).classList.add("active");
    });
  });
});
// end on wifi marketing  video tab open

  //  careers page Our-Job-Opportunity section accordation
  document.querySelectorAll('.block__section-Our-Job-Opportunity_btn').forEach(tab => {
    tab.addEventListener("click", (event) => {
        event.preventDefault();
        let innerContent = event.currentTarget.closest('.block__section-Our-Job-Opportunity-grid_item');
        if (!innerContent) return; 
        let button = event.currentTarget; 
        // Close other active items
        document.querySelectorAll('.block__section-Our-Job-Opportunity-grid_item.careers-active')
        .forEach(el => {
            if (el !== innerContent) {
                el.classList.remove('careers-active');
                el.querySelector('.block__section-Our-Job-Opportunity_btn').textContent = "View More"; 
            }
        });
        if (innerContent.classList.contains('careers-active')) {
            innerContent.classList.remove('careers-active');
            button.textContent = "View More";
        } else {
            innerContent.classList.add('careers-active');
            button.textContent = "View Less";
        }
    });
});

if(document.querySelector('.block__readmore-btn') != null ){
document.querySelector('.block__readmore-btn').addEventListener('click', (event) => {
  event.preventDefault();
  var __this = event.currentTarget;
  __this.closest('.product__description').classList.toggle('showmore');
});
}

function readmore_less_Drawer(event) {
  event.preventDefault();
  var __this = event.currentTarget;
  var container = __this.closest('.membership_information');
  if (container) {
    container.classList.toggle('showmore');
  }
}

if(document.querySelector('.block__trax-readmore-less-text') != null ){
  document.querySelectorAll('.block__trax-readmore-less-text').forEach((read_more_trax) => {
    read_more_trax.addEventListener('click', (event) => {
      event.preventDefault();
      var __this = event.currentTarget;
      if(__this.closest('.block__step-1-products-description') != null ){
        __this.closest('.block__step-1-products-description').classList.toggle('showmore');
      }
      if(__this.closest('.block__step-2-products-description') != null ){
        __this.closest('.block__step-2-products-description').classList.toggle('showmore');
      }
    });
  });
  document.querySelectorAll('.step-pro-desciprion').forEach(desc => {
    if (desc.offsetHeight <= 35) {
      desc.nextElementSibling.classList.add('visually-hidden');
    }
  });
}

if(document.querySelector('.block__product-description-hideshow') != null ){
document.addEventListener('DOMContentLoaded', function () {
  var description_height = document.querySelector('.block__product-description-hideshow').offsetHeight;
  if(description_height < 225){
    document.querySelector('.product__description-before-layer').classList.add('hide');
  }
});
}


// onClick Metobject tab change
document.querySelectorAll('.block__object-tabbing--tab-name a').forEach((meta_object_tab) => {
  meta_object_tab.addEventListener("click", onClick_Metaobject_tabbing);
});

function onClick_Metaobject_tabbing(event) {
  event.preventDefault();
  const __this = event.currentTarget;
  const tab_href = __this.getAttribute('href');
  document.querySelectorAll('.block__object-tabbing--tab-name').forEach((nav_tab) => {
    nav_tab.classList.remove('nav-active');
  });
  document.querySelectorAll('.block__metaobject-product-content').forEach((meta_section_id) => {
    meta_section_id.classList.remove('active');
  });
  __this.parentNode.classList.add('nav-active');
  if(document.querySelector(tab_href) != null) {
    document.querySelector(tab_href).classList.add('active');
  }
}

// on click open tab faq on PDP page
document.querySelectorAll('.block__metaobject-product-faq-title').forEach((tab_faq) => {
  tab_faq.addEventListener("click", OnClickFaqOpen);
});

function OnClickFaqOpen(event){
  event.preventDefault();
  var __this = event.currentTarget;
  if(__this.closest('.block__metaobject-product-faq-with-content-wrapper').classList.contains('faq-active')){
    __this.closest('.block__metaobject-product-faq-with-content-wrapper').classList.remove('faq-active');
  } else {
    var remove_class = __this.closest('.block__metaobject-product-faq-with-content--main').querySelectorAll('.block__metaobject-product-faq-with-content-wrapper');
    remove_class.forEach(el=>el.classList.remove('faq-active'));
    __this.closest('.block__metaobject-product-faq-with-content-wrapper').classList.add('faq-active');
  }
}


// key features tab on PDP
document.querySelectorAll('.block__key-features-heading').forEach((open_faq) => {
  open_faq.addEventListener('click', (event) => {
    event.preventDefault();
    var __this = event.currentTarget;
    if(__this.closest('.block__key-features-main') != null ){
      __this.closest('.block__key-features-main').classList.toggle('open');
    }
  });
});

// start select package on pdp
if(document.querySelectorAll('.block__swing-trax-products').length > 0) {
  document.querySelectorAll('.block__swing-trax-products .block__step-2-products--input-checkbox').forEach((validation_products) => {
    validation_products.addEventListener("click", onClick_validate_to_next_step);
  });
  function onClick_validate_to_next_step(event) {
    const __this = event.currentTarget;
    let validation_checkbox = __this.closest('.block__step-2-products--info').querySelectorAll('input:checked').length;
    if(validation_checkbox > 0) {
      __this.closest('.block__step-2-products--info').querySelector('.block__step-products--next-buttons').removeAttribute("disabled","disabled");
    }else {
      __this.closest('.block__step-2-products--info').querySelector('.block__step-products--next-buttons').setAttribute("disabled","disabled");
    }
  }
}
// Next button
if(document.querySelectorAll('.block__step-products--next-buttons').length > 0) {
  document.querySelectorAll('.block__step-products--next-buttons').forEach((next_step) => {
    next_step.addEventListener("click", onClick_show_next_step);
  });

  function onClick_show_next_step(event) {
    const __this = event.currentTarget;
    let products_radio = document.querySelectorAll(".block__step-products--info input:checked");
    let cartItems = [];
    let totalPrice = 0;
    products_radio.forEach(product => {
      let productId = product.getAttribute('data-pro-id');
      let productTitle = product.getAttribute('data-pro-title');
      let productImage = product.getAttribute('data-pro-image');
      let productPrice = product.getAttribute('data-pro-price');
      if(productId != null && productId != '') {
        let priceValue = parseFloat(productPrice) || 0;
        totalPrice += priceValue;
        cartItems.push({
            id: productId,
            title: productTitle,
            image: productImage,
            price: productPrice
        });
      }
    });
    let step_4_content = document.querySelector('.block__step-4-products--content');
    let step_4_totals = document.querySelector('.block__step-4-products--totals');
    let productWrapper = document.createElement("div");
    productWrapper.classList.add("block__items-container");
    let productTotals = document.createElement("div");
    let product_html_div ;
      cartItems.forEach(item => {
      product_html_div = document.createElement("div");

      let item_image = (item.image && item.image !== "null") ? item.image : '';
      product_html_div.innerHTML += `
      <div class="block__items-element-main">
        ${item_image ? `
        <div class="block__items-element-image">
          <img src="${item_image}" alt="pro-image" />
        </div>
      ` : ''}

        <div class="block__items-element-title-with-price">
          <span class="block__items-element-title">${item.title}</span>
          <span class="block__items-element-price">${Shopify.formatMoney(item.price)}</span>
        </div>
      </div>`
      ;
      productWrapper.appendChild(product_html_div);
      productTotals.innerHTML = `
          <div class="block__total-price">
            <span class="block__total-text">Total</span
            <span class="block__total-price">${Shopify.formatMoney(totalPrice)}</span>
          </div>`;
    });
    step_4_content.innerHTML = "";
    step_4_content.appendChild(productWrapper);
    step_4_totals.innerHTML = "";
    step_4_totals.appendChild(productTotals);


    document.querySelectorAll('.block__step-products--info').forEach((all_step_element) => {
      all_step_element.style.display = "none";
    });
    __this.closest('.block__step-products--info').nextElementSibling.style.display = "block";
    document.querySelectorAll('.step-pro-desciprion').forEach(desc => {
      if (desc.offsetHeight <= 35) {
        desc.nextElementSibling.classList.add('visually-hidden');
      } else {
        desc.nextElementSibling.classList.remove('visually-hidden');
      }
    });
  }
}


// prev button
if(document.querySelectorAll('.block__step-products--prev-buttons') != null) {
  document.querySelectorAll('.block__step-products--prev-buttons').forEach((prev_step) => {
    prev_step.addEventListener("click", onClick_show_prev_step);
  });

  function onClick_show_prev_step(event) {
    const __this = event.currentTarget;
    document.querySelectorAll('.block__step-products--info').forEach((all_step_element) => {
      all_step_element.style.display = "none";
    });
    __this.closest('.block__step-products--info').previousElementSibling.style.display = "block";
    document.querySelectorAll('.step-pro-desciprion').forEach(desc => {
      if (desc.offsetHeight <= 35) {
        desc.nextElementSibling.classList.add('visually-hidden');
      } else {
        desc.nextElementSibling.classList.remove('visually-hidden');
      }
    });
  }
}

// select option change
if(document.querySelectorAll('.block__step-3-products-select') != null) {
  document.querySelectorAll('.block__step-3-products-select').forEach((select_value) => {
    let selectedOption = select_value.options[select_value.selectedIndex];
    let selectedOption_title = selectedOption.getAttribute("data-pro-title");
    let selectedOption_image = selectedOption.getAttribute("data-pro-image");
    let selectedOption_price = selectedOption.getAttribute("data-pro-price");
    let selectedOption_input = select_value.closest('.block__member-ship-products-select-option').querySelector('input');
    selectedOption_input.setAttribute('data-pro-id',select_value.value);
    selectedOption_input.setAttribute('data-pro-title',selectedOption_title);
    selectedOption_input.setAttribute('data-pro-image',selectedOption_image);
    selectedOption_input.setAttribute('data-pro-price',selectedOption_price);
  });

  document.querySelectorAll('.block__step-3-products-select').forEach((select_value) => {
    select_value.addEventListener("change", onChange_set_attribute);
  });
  function onChange_set_attribute(event) {
    const __this = event.currentTarget;
    let selectedValue = __this.value;
    let selectedIndex = __this.selectedIndex;
    let selectedOption = __this.options[selectedIndex];
    let selectedTitle = selectedOption.getAttribute('data-pro-title');
    let selectedImage = selectedOption.getAttribute('data-pro-image');
    let selectedPrice = selectedOption.getAttribute('data-pro-price');
    let input_element = __this.closest('.block__member-ship-products-select-option').querySelector('input');
    input_element.setAttribute('data-pro-id',selectedValue);
    input_element.setAttribute('data-pro-title',selectedTitle);
    input_element.setAttribute('data-pro-image',selectedImage);
    input_element.setAttribute('data-pro-price',selectedPrice);
  }
}

//upsell Add to cart button on pdp
document.querySelectorAll('.block__step-products--addtocart').forEach((atc_value) => {
  atc_value.addEventListener("click", onClickAddToCartProducts);
});
function onClickAddToCartProducts(event) {
  event.preventDefault();
  let selectedProducts  = document.querySelectorAll(".block__step-products--info input:checked");
  let productItems = [];
  selectedProducts.forEach(product => {
    let productId = product.getAttribute('data-pro-id');
    if(productId != null && productId != '') {
      productItems.push({
          id: productId,
          quantity: 1
      });
    }
  });
  if (productItems.length === 0) {
    return;
  }
  let product_atc_formData = {items:productItems, sections_url:window.location.pathname, sections:document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id)};
  $sample_atc_submit_event(product_atc_formData);
}
// end select package on pdp

// start select view plan benefit table
function onClickAddToCartProductsViewPlans(event) {
  let selectedProductInput = document.querySelector(".block__membership-product-table-products input:checked");

  if (!selectedProductInput) return;

  let selectedProductId = selectedProductInput.value;
  let selectedSellingPlanId = selectedProductInput.getAttribute('data-selling-id');
  let selectedProperty = selectedProductInput.getAttribute('data-property');
  let freeGolf = selectedProperty ? true : false;
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cartData) => {
      let alreadyInCart = cartData.items.some(item => {
        return item.variant_id == selectedProductId;
      });

      if (alreadyInCart) {
        console.log('Product already in cart');
        return;
      }

      let formData = [{
        id: selectedProductId,
        quantity: 1,
        selling_plan: selectedSellingPlanId,
        properties: {
          _free_golf: freeGolf,
          _membership_pro: true
        }
      }];
      let productATCData = {items: formData,sections_url: window.location.pathname,sections: document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id)};
      $sample_atc_submit_event(productATCData);
    });
}
// end select view plan benefit table

// start onclick subscribe button on drawer to add membership products
function onClickAddToCartmembersProducts(event) {
  // event.preventDefault();
  let selectedProduct  = document.querySelectorAll(".block__membership-var-id");
  let productItems1 = [];
  selectedProduct.forEach(products => {
    let productIds = products.value;
    let selectedProperty = products.getAttribute('data-membership');
    if(productIds != null) {
      productItems1.push({
          id: productIds,
          quantity: 1,
          properties: {
            _membership_pro: selectedProperty
          }
      });
    }
  });
  if (productItems1.length === 0) {
    return;
  }
  let product_atc_formData = {items:productItems1, sections_url:window.location.pathname, sections:document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id)};
  $sample_atc_submit_event(product_atc_formData);
}
// end onclick subscribe button on drawer to add membership products


const $sample_atc_submit_event = async function($form_data){
  const $sample_addtocart_result = await fetch('/cart/add.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify($form_data)
  });
  const $atc_success_result = await $sample_addtocart_result.json();
  if($atc_success_result.items){
    if (document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('cart-drawer').classList.remove('is-empty');
      document.querySelector('cart-drawer').renderContents($atc_success_result);
      setTimeout(function(){
        const you_may_also_like_products = document.querySelectorAll('.block__you-may-also-like-products-slider.swiper');
        if(you_may_also_like_products.length > 0) {
          you_may_also_like_products && you_may_also_like_products.forEach(drawer_upsell => {
            new Swiper(drawer_upsell, {
              spaceBetween: 12,
              loop: true,
              navigation: {
              nextEl: '.block__you-may-also-like-products-slider-arrow-right',
              prevEl: '.block__you-may-also-like-products-slider-arrow-left',
              },
              breakpoints: {
              310: {
                  slidesPerView: 2.1,
                  spaceBetween: 12,
              },
              610: {
                  slidesPerView: 2.4,
                  spaceBetween: 12
              }
            }
            });
          });
        }
      },1500);
  } else{
    console.error($atc_success_result);
  }
}

// Trigger addtocart with membership product button on pdp
document.querySelectorAll('.block__products-variant--button .product-form-button').forEach((atc_trigger) => {
  atc_trigger.addEventListener("click", onClickAddToCartTrigger);
});
function onClickAddToCartTrigger(event) {
  event.preventDefault();
  var __this = event.currentTarget;
  var data_match_id = __this.getAttribute('data-membership-item');
  document.querySelectorAll('.block__product-option-main-product').forEach(products => {
    products.removeAttribute('checked');
  });
  document.getElementById(data_match_id).querySelector('.block__product-option-main-product')?.click();
  document.querySelector('[id^="ProductSubmitButton-"]')?.click();
}

// Smooth scroll animation
document.addEventListener('click', function(event) {
  if (event.target.tagName === 'A' && event.target.getAttribute('data-scroll-id')?.startsWith('#')) {
      event.preventDefault();

      const targetId = event.target.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      const targetPosition = targetElement.getBoundingClientRect().top;
      window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
      });
  }
});
document.addEventListener("DOMContentLoaded", function() {
  let images = document.querySelectorAll(".press_article_wrapper img");

  images.forEach((img, index) => {
      if (index === 0) {
        img.classList.add("full-width-img");
          return;
      } else if (index % 2 === 1) {
          img.classList.add("float-left"); 
      } else {
          img.classList.add("float-right");
      }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  let images = document.querySelectorAll(".main_article_wrapper img");

  images.forEach((img, index) => {
      if ((index + 1) % 2 === 0) {
          img.classList.add("float-right");
      } else {
          img.classList.add("float-left");
      }
  });
});

//  Card Information same height JS
function equl(name) {
  let heading = document.querySelectorAll(name);
  let titleHeight = 0;
  heading.forEach((title) => {
    let matchHeight = title.clientHeight;
    if (matchHeight > titleHeight) {
      titleHeight = title.clientHeight;
    }
  });
  heading.forEach((divHeight) => {
    divHeight.style.minHeight = titleHeight + "px";
  });
}
document.addEventListener("DOMContentLoaded", function (event) {
  setTimeout(() => {
    equl(".block__trending_blog_col .article-card-wrapper .card__heading ");
    equl(".main-blog .article-card-wrapper .card__heading ");
    equl(".block__trade_marketing_img_text_content p");
    equl(".block__how_it_work_content h5");
    equl(".article-card-wrapper .card__information h3");
  }, 300);
});

//  Blog Search js
// for search filter
document.addEventListener('keyup', function (e) {
  if (e.target.id === 'search-blogs') {
    const searchClear = document.querySelector('.blog__search .blog--search-clear');
    if (e.target.value.length > 0 || !searchClear.offsetParent) {
      searchClear.style.display = 'block';
    }
  }
});

document.addEventListener('keydown', function (e) {
  if (e.target.closest('.blog__search') && e.key === "Enter") {
    blogPredictiveSearch(e);
  }
});

document.addEventListener('click', function (e) {
  if (e.target.closest('.blog__search button')) {
    blogPredictiveSearch(e);
  }

  if (e.target.closest('.blog__search .blog--search-clear')) {
    document.querySelector('#search-blogs').value = '';
    fetch(window.location.href)
      .then(response => response.text())
      .then(responseHTML => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseHTML, 'text/html');
        const articleGrid = doc.querySelector('.blog-articles');
        
        if (articleGrid && articleGrid.innerHTML.trim().length > 0) {
          document.querySelector('.blog-articles').innerHTML = articleGrid.innerHTML;
        } else {
          document.querySelector('.blog-articles').innerHTML = '<p class="medium_body">Articles Not Found !!!</p>';
        }
        document.querySelector('.main-blog .pagination-wrapper').classList.remove('hidden');
      });
    e.target.style.display = 'none';
  }
});

function blogPredictiveSearch(e) {
  e.preventDefault();
  const inputVal = document.querySelector('#search-blogs').value;
  const urlWithParams = '/search?view=search-2&type=article&q='+inputVal;
  fetch(urlWithParams)
    .then(response => response.text())
    .then(responseHTML => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, 'text/html');
      const articleGrid = doc.querySelector('.blog-articles');
      
      if (articleGrid && articleGrid.innerHTML.trim().length > 0) {
        document.querySelector('.blog-articles').innerHTML = articleGrid.innerHTML;
      } else {
        document.querySelector('.blog-articles').innerHTML = '<p class="medium_body">Articles Not Found !!!</p>';
      }
      document.querySelector('.main-blog .pagination-wrapper').classList.add('hidden');
    });
}

document.querySelectorAll(".blog--search-clear").forEach(clearBtn => {
  clearBtn.addEventListener("click", function () {
    setTimeout(() => {
      document.activeElement.blur();
    }, 100);
  });
});


// Copy Link Js
document.addEventListener("DOMContentLoaded", function() {
  if (!document.body.classList.contains("template-article")) {
      return; 
  }

  const svgElement = document.getElementById("copy_link_icon");
  const copyTextElements = document.getElementsByClassName("copy_text");

  if (svgElement) {
      svgElement.addEventListener("click", function() {
          const pageUrl = window.location.href;
          navigator.clipboard.writeText(pageUrl).then(() => {
              if (copyTextElements.length > 0) {
                  const copyText = copyTextElements[0];
                  copyText.classList.add('show');
                  setTimeout(() => {
                      copyText.classList.remove('show');
                  }, 3000);
              }
          }).catch(err => {
              console.error("Failed to copy URL:", err);
          });
      });
  } else {
      console.error("SVG element not found!");
  }
});



  // Address Page pop-up
document.addEventListener("DOMContentLoaded", function () {
  const tabItems = document.querySelectorAll(".main_account-tabitem");
  const tabContents = document.querySelectorAll(".main_account_tabcontentwrap");
  const breadcrumb = document.querySelector(".block__pagebanner-breadcrumb-heading");
  const mobileFilter = document.querySelector(".main_account-tab-mobilefilter .current_tab");
  const tabList = document.querySelector(".main_account-tablist");
  const mobileFilterButton = document.querySelector(".main_account-tab-mobilefilter");

  function activateTab(tabName) {
      tabItems.forEach(item => item.classList.toggle("main_accounttab-active", item.dataset.accounttab === tabName));
      tabContents.forEach(content => content.classList.toggle("main_accounttabcontent-active", content.dataset.accounttabcontent === tabName));

      const activeTab = document.querySelector(`.main_account-tabitem[data-accounttab="${tabName}"]`);
      if (activeTab) {
          const tabText = activeTab.querySelector("a").innerText;
          if (breadcrumb) breadcrumb.textContent = tabText;
          if (mobileFilter) mobileFilter.textContent = tabText;
          localStorage.setItem("account_current_tab", tabName);
      }
  }

  // Get saved tab or use the first tab
  let savedTab = localStorage.getItem("account_current_tab");
  let firstTab = tabItems[0]?.dataset.accounttab;

  let currentTab = savedTab && [...tabItems].some(tab => tab.dataset.accounttab === savedTab) 
      ? savedTab 
      : firstTab;

  // activateTab(currentTab);

  tabItems.forEach(tab => {
      if (!tab.classList.contains("main_account-tabitemlogout")) {
          tab.addEventListener("click", () => activateTab(tab.dataset.accounttab));
      }
  });

  function handleResponsiveTabs() {
      if (window.innerWidth < 991 && tabList) {
          tabList.style.display = "none";
          mobileFilterButton?.removeEventListener("click", toggleTabList);
          mobileFilterButton?.addEventListener("click", toggleTabList);
      } else if (tabList) {
          tabList.style.display = "";
      }
  }

  function toggleTabList() {
      mobileFilterButton.classList.toggle("tab-filter-openn");
      tabList.style.display = tabList.style.display === "none" ? "block" : "none";
  }

  handleResponsiveTabs();
  window.addEventListener("resize", handleResponsiveTabs);
});


// Tabify Js 
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".block__calendar_event_tab_col ul li");
  const tabContents = document.querySelectorAll(".block__calendar_event_tab_content_box");

  tabs.forEach(tab => {
      tab.addEventListener("click", function () {
          tabs.forEach(t => t.classList.remove("active"));
          this.classList.add("active");
          const targetTab = this.id;
          tabContents.forEach(content => {
              content.classList.toggle("active", content.dataset.tab === targetTab);
          });
      });
  });

  // Show the first tab and content by default
  if (tabs.length > 0) {
      tabs[0].classList.add("active");
      const firstTabId = tabs[0].id;
      tabContents.forEach(content => {
          content.classList.toggle("active", content.dataset.tab === firstTabId);
      });
  }
});

// Policy section redirect js
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.policy_page a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener("click", function (e) {
          e.preventDefault();
          var targetId = this.getAttribute("href").substring(1); 
          var targetElement = document.getElementById(targetId); 
          if (targetElement) {
              window.scrollTo({
                  top: targetElement.offsetTop - 130,
                  behavior: "smooth"
              });
          }
      });
  });
});
// Event Page View More JS

document.addEventListener("DOMContentLoaded", function () {
  function initializeEventBoxes() {
      let activeTab = document.querySelector(".block__calendar_event_tab_col ul li.active");
      if (!activeTab) {
          activeTab = document.querySelector(".block__calendar_event_tab_col ul li:first-child");
          if (activeTab) activeTab.classList.add("active");
      }

      let activeTabId = activeTab ? activeTab.getAttribute("id") : null;
      document.querySelectorAll(".block__calendar_event_tab_content_box").forEach(box => {
          box.classList.remove("active");
          box.classList.add("hidden"); 
      });

      if (activeTabId) {
        
          let eventBoxes = document.querySelectorAll(`.block__calendar_event_tab_content_box[data-tab="${activeTabId}"]`);
          let viewMoreButton = document.querySelector(".block__calendar_event_bottom_col");

          eventBoxes.forEach((box, index) => {
              box.classList.add("active");
              if (index < 9) {
                  box.classList.remove("hidden"); 
              }
          });
          if (eventBoxes.length > 9) {
              viewMoreButton.classList.remove("hidden"); 

              viewMoreButton.querySelector("a").onclick = function (event) {
                  event.preventDefault();
                  eventBoxes.forEach(box => {
                      box.classList.remove("hidden"); 
                  });
                  viewMoreButton.classList.add("hidden"); 
              };
          } else {
              viewMoreButton.classList.add("hidden"); 
          }
      }
  }
  initializeEventBoxes();
  document.querySelectorAll(".block__calendar_event_tab_col ul li").forEach(tab => {
      tab.addEventListener("click", function () {
          document.querySelectorAll(".block__calendar_event_tab_col ul li").forEach(t => t.classList.remove("active"));
          this.classList.add("active");
          setTimeout(initializeEventBoxes, 100); 
      });
  });
});


// View plan benefits button click on PDP page
  document.querySelectorAll('.block__view-plan-benefits').forEach(function (page_content) {
    page_content.addEventListener("click", function (e) {
      e.preventDefault();
      const benefit_page_url = e.currentTarget.getAttribute('href');

      fetch(`${benefit_page_url}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sectionContent = html.querySelector("#block__membership-benefits-table");
          if (sectionContent) {
            document.querySelector('.block__view-plan-benefits-popup--main').classList.add('open-popup');
            document.body.classList.add('overflow-hidden');
            document.querySelector('.block__view-plan-benefits-popup--inner').innerHTML = sectionContent.innerHTML;
          }
        })
        .catch(error => console.error("Error fetching content:", error));
    });
  });
  document.querySelectorAll('.block__view-plan-benefits-popup--close,.block__view-plan-benefits-popup--overlay').forEach(function (close_popup) {
    close_popup.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector('.block__view-plan-benefits-popup--main').classList.remove('open-popup');
      document.body.classList.remove('overflow-hidden');
      document.querySelector('.block__view-plan-benefits-popup--inner').innerHTML = '';
    });
  });

// Comparison Product Js
document.addEventListener("DOMContentLoaded", function () {
  let comparisonPopup = document.querySelector(".block__comparison_product_wrapper");
  let openPopupBtns = document.querySelectorAll(".comparison_add_product_btn");
  let closePopupBtn = document.querySelector(".comparison_add_product_close_btn");
  let selectProductBtns = document.querySelectorAll(".select_product_btn");
  let clearComparisonBtn = document.querySelector(".product_compare_clear_btn");
  let body = document.querySelector("body");

  let comparisonTable = {
    productImgContainers: document.querySelectorAll(".product_img_container"),
    display1: document.getElementById("comparison_body_dimension"),
    display2: document.getElementById("comparison_case_thickness"),
    display3: document.getElementById("comparison_weight"),
    display4: document.getElementById("comparison_display_resolution"),
    display5: document.getElementById("comparison_water_resistant"),
    display6: document.getElementById("comparison_languages"),
    display7: document.getElementById("comparison_display"),
    addToCart: document.getElementById("add_to_cart_btn"),
  };

  let maxProducts = 4;
  let selectedProducts = getCookie("selectedProducts") ? JSON.parse(getCookie("selectedProducts")) : [];

  function setCookie(name, value, hours) {
    let d = new Date();
    d.setTime(d.getTime() + hours * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + JSON.stringify(value) + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i].trim();
      if (c.indexOf(name + "=") === 0) {
        return c.substring(name.length + 1);
      }
    }
    return "";
  }

  function updatePopupProducts() {
    let productItems = document.querySelectorAll(".block__comparison_product_box");

    productItems.forEach((item) => {
      let productId = item.querySelector(".select_product_btn")?.getAttribute("data-variant-id");
      let isSelected = selectedProducts.some((product) => product.productHandle === productId);

      if (isSelected) {
        item.classList.add("selected_product_remove");
      } else {
        item.classList.remove("selected_product_remove");
      }
    });
  }

  function updateComparisonTable(products) {
    setCookie("selectedProducts", products, 24);
    comparisonTable.productImgContainers.forEach((container, index) => {
      container.innerHTML = "";
      let button = container.previousElementSibling;
      if (products[index]) {
        let img = document.createElement("img");
        img.src = products[index].productImage;
        img.alt = "Product Image";
        img.style.width = "50px";
        container.appendChild(img);
        
        let removeBtn = document.createElement("button");
        removeBtn.textContent = "Remove Product";
        removeBtn.classList.add("remove-product-btn");
        removeBtn.dataset.productIndex = index;
        removeBtn.addEventListener("click", function () {
          selectedProducts.splice(index, 1);
          updateComparisonTable(selectedProducts);
        });
        container.appendChild(removeBtn);
        
        button.style.display = "none";
      } else {
        button.style.display = "inline-block";
      }
    });

    Object.keys(comparisonTable).forEach((key) => {
      if (key !== "productImgContainers" && comparisonTable[key]) {
        let header = comparisonTable[key].querySelector("th");
        comparisonTable[key].innerHTML = header ? "<th class='body mobile_sticky'>" + header.textContent + "</th>" : "";
      }
    });

    products.forEach((product, index) => {
      comparisonTable.display1.appendChild(createCell(product.bodyDimension));
      comparisonTable.display2.appendChild(createCell(product.caseThickness));
      comparisonTable.display3.appendChild(createCell(product.weight));
      comparisonTable.display4.appendChild(createCell(product.displayResolution));
      comparisonTable.display5.appendChild(createCell(product.waterResistant));
      comparisonTable.display6.appendChild(createCell(product.languages));
      comparisonTable.display7.appendChild(createCell(product.productDisplay));

      let cartCell = document.createElement("td");
      let addToCartBtn = document.createElement("button");
      addToCartBtn.textContent = "Add to Cart";
      addToCartBtn.classList.add("add-to-cart-btn-compare");
      addToCartBtn.dataset.variantId = product.productHandle;

      addToCartBtn.addEventListener("click", function (event) {
        let compare_product_id = event.currentTarget.getAttribute("data-variant-id");
        let formData = [{ id: compare_product_id, quantity: 1 }];
        let product_atc_formData = {
          items: formData,
          sections_url: window.location.pathname,
          sections: document.querySelector("cart-drawer").getSectionsToRender().map((section) => section.id),
        };
        $sample_atc_submit_event(product_atc_formData);
      });

      cartCell.appendChild(addToCartBtn);
      comparisonTable.addToCart.appendChild(cartCell);
    });
  }

  function createCell(text) {
    let td = document.createElement("td");
    td.textContent = String(text);
    return td;
  }

  openPopupBtns.forEach((button) => {
    button.addEventListener("click", function () {
      updatePopupProducts(); // Remove already selected products
      comparisonPopup.style.display = "flex";
      body.classList.add("overflow-hidden");
    });
  });

  if (closePopupBtn) {
    closePopupBtn.addEventListener("click", function () {
      comparisonPopup.style.display = "none";
      body.classList.remove("overflow-hidden");
    });
  }

  selectProductBtns.forEach((button) => {
    button.addEventListener("click", function () {
      let productId = this.getAttribute("data-variant-id");
      if (!productId) return;
      let productData = {
        productDisplay: this.getAttribute("data-comparison-display") || "N/A",
        bodyDimension: this.getAttribute("data-comparison-body-dimension") || "N/A",
        caseThickness: this.getAttribute("data-comparison-case-thickness") || "N/A",
        weight: this.getAttribute("data-comparison-weight") || "N/A",
        displayResolution: this.getAttribute("data-comparison-display-resolution") || "N/A",
        waterResistant: this.getAttribute("data-comparison-water-resistant") || "N/A",
        languages: this.getAttribute("data-comparison-languages") || "N/A",
        productHandle: productId,
        productImage: this.getAttribute("data-comparison-product-image") || "N/A",
      };
      selectedProducts.push(productData);
      updateComparisonTable(selectedProducts);
      comparisonPopup.style.display = "none";
      body.classList.remove("overflow-hidden");
    });
  });

  if (clearComparisonBtn) {
    clearComparisonBtn.addEventListener("click", function () {
      selectedProducts = [];
      setCookie("selectedProducts", [], 24);
      updateComparisonTable(selectedProducts);
    });
  }

  if (selectedProducts.length > 0) {
    updateComparisonTable(selectedProducts);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.querySelector(".block__comparison_overlay");
  const wrapper = document.querySelector(".block__comparison_product_wrapper");

  if (overlay && wrapper) {
    overlay.addEventListener("click", function () {
      wrapper.style.display = "none";
    });
  }
});

// Newslatter sign up form css start



function applyCustomFormStyles(shadowRoot, formId) {
  if (!shadowRoot) return;
  if (shadowRoot.querySelector("#custom-style-" + formId)) return; 

  const style = document.createElement("style");
  style.id = "custom-style-" + formId; 

  // Default styles for all forms
  let commonStyles = `
      section._formHeader_1nihh_19{
          margin: 0px auto 30px !important;
      }
      ._formError_1ydxd_20{
            text-align: left;
      }
      form._formFieldset_1nihh_63{
          gap: 12px !important;
      }
      ._inline_stahb_47 ._formContainer_stahb_30 {
          max-width: 100% !important;
      }
      h2._textHeading_2aowh_35{
          font-size:28px !important;
          margin-bottom:12px !important;
          font-style:italic !important;
          font-family: var(--font-heading-family) !important;
      }
      ._textBody_2aowh_10, span._textBody_2aowh_10, p._textBody_2aowh_10{
          font-size:18px !important;
          font-family: var(--font-heading-family) !important;
      }
      input._formInputField_237zm_7 , input._formPhoneInputField_1ym3p_17 {
          background: rgba(var(--color-foreground), .06) !important;
          border: 1px solid rgba(var(--color-foreground), .06) !important;
          color: rgb(var(--color-foreground)) !important;
          text-align: left !important;
          padding: 1.5rem 2.4rem!important;
          border-radius: var(--inputs-radius) !important;
          line-height: 22px !important;
          font-family: var(--font-heading-family) !important;
          box-shadow: none !important;
      }
      ._selectToggle_1yit2_25{
        background: rgba(var(--color-foreground), .06) !important;
        border: 1px solid rgba(var(--color-foreground), .06) !important;
        max-height: 54px !important;
        padding-left: 2px !important;
        padding-right: 0 !important;
      }
      input._formInputField_237zm_7:focus-visible .input._formPhoneInputField_1ym3p_17:focus-visible {
          box-shadow:none !important;
      }
      ._formInputFieldLabel_1ydxd_37 {
          color: rgba(var(--color-foreground), 0.55) !important;
          line-height: 18px !important;
          font-family: var(--font-heading-family) !important;
          left: 24px !important;
          top:18px !important;
      }
      ._formFieldContainer_1ydxd_5 ._inputFilled_1ydxd_73{
        top: 0px !important;
      }
      #label-phone_number{
        top:13px !important;
      }
      ._formFieldContainer_1ydxd_5:focus-within ._formInputFieldLabel_1ydxd_37  , ._formFieldContainer_1ydxd_5:focus-within #label-phone_number._formInputFieldLabel_1ydxd_37{
        top: 1px !important;
        width: auto !important;
      }
      ._formInputField_237zm_7:focus-within ._formInputFieldLabel_1ydxd_37{
        opacity:0 !important; 
      }
      div._formDisclaimer_1nihh_33{
        margin-top:20px !important;
        font-size:14px !important;
        font-family: var(--font-heading-family) !important;
        opacity:.5 !important;
      }
      button._formSubmitButton_1nihh_77 {
        position:relative;
        margin-top:16px !important;
        font-size:18px !important;
        font-family: var(--font-heading-family) !important;
        font-weight: 700 !important;
        padding: 1.861rem 2rem !important;
        border-radius: 30px !important;
        transition: all .3s ease-in-out !important;
        border:2px solid var(--primary-color) !important;
     }
      button._formSubmitButton_1nihh_77:focus-visible, button._formSubmitButton_1nihh_77:hover {
          background-color: rgb(var(--color-button-text)) !important;
          color: var(--primary-color) !important;
          border:2px solid var(--primary-color) !important;
      }
      ._formBannerContainer_z5ku3_1 ._formBannerHeading_z5ku3_9 {
          font-size: 28px !important;
          margin-bottom: 12px !important;
          font-style: italic !important;
          font-family: var(--font-heading-family) !important;
      }
      button._copyToClipboardButton_1q0xm_2 {
          border-radius: 30px !important;
          padding: 1.5rem 2rem !important;
          background-color: var(--primary-color) !important;
      }
      ._textBody_2aowh_10{
          opacity:.7;
          font-family: var(--font-heading-family) !important;
          font-size: 14px !important;
      }
      span._copyToClipboardText_1q0xm_23 {
        color: var(--button-text-color) !important;
        font-family: var(--font-heading-family) !important;
        font-size:16px !important;
      }
      ._copyIcon_1q0xm_31 path {
          fill: var(--button-text-color) !important; 
      }
      ._formDisclaimer_1nihh_33 p{
          margin-top:20px !important;
      }
     ._inline_stahb_47{
        overflow:unset !important;
      }
      ._inline_stahb_47 ._formContainer_stahb_30{
        overflow: unset !important;
      }
     ._formPhoneInputContainer_1ym3p_6{
          display: flex !important;
        flex-direction: column;
      }
      ._selectContainer_1yit2_6{
        display:none !important;
      }
    #form-container-ref{
      width:100%;
    }
    button._formSubmitButton_1nihh_77:focus-visible, button._formSubmitButton_1nihh_77:hover{
        filter: unset !important;
    }
    @media (max-width: 989px) {
      h2._textHeading_2aowh_35{
          font-size:24px !important;
      }
      ._formBannerContainer_z5ku3_1 ._formBannerHeading_z5ku3_9 {
          font-size:24px !important;
      }
      ._textBody_2aowh_10, span._textBody_2aowh_10, p._textBody_2aowh_10{
          font-size:16px !important;
      }
    }
    @media screen and (max-width: 490px) {
      ._container_3eyaa_70 {
        display:flex !important;
      } 
    }

  `;

  // Additional styles ONLY for Form ID: 401265
  if (formId === "forms-root-401265") {
      commonStyles += `
      ._inline_stahb_47 ._formContainer_stahb_30{
          min-height: auto !important;
      }
       button._formSubmitButton_1nihh_77{
          position: absolute !important;
          margin: 0 !important;
          height: auto !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          right: 6px !important;
          padding: 11px 0 !important;
          min-height: auto !important;
          min-width: 130px !important;
          width: 4.4rem !important;
          font-size: 1.6rem !important;
          line-height: 2.4rem !important;
       }
        input._formInputField_237zm_7{
          background-color: var(--quaternary-color) !important;
          color: var(--secondary-color) !important;
          border-radius: 40px !important;
          padding: 19px 28px !important;
          padding-right: 140px !important;
          font-size:16px !important;
        }
        label._formInputFieldLabel_1ydxd_37{
          color: rgba(0, 0, 0, 0.6) !important;
          font-size:16px !important;
        }
        ._formInputFieldLabel_1ydxd_37{
            left: 28px !important;
            top: 23px !important;
        }
            ._formFieldContainer_1ydxd_5 ._inputFilled_1ydxd_73{
              display:none;
            }
        ._formFieldContainer_1ydxd_5:focus-within ._formInputFieldLabel_1ydxd_37, ._formFieldContainer_1ydxd_5:focus-within #label-phone_number._formInputFieldLabel_1ydxd_37{
          display:none;
        }
          ._formBannerContainer_z5ku3_1 ._formBannerHeading_z5ku3_9{
              font-size: calc(var(--heading-font-size)* 0.8) !important;
          }
        @media (max-width: 989px) {
          input._formInputField_237zm_7, label._formInputFieldLabel_1ydxd_37{ 
              font-size: 1.4rem !important;
          }
          input._formInputField_237zm_7{
                padding: 17px 28px !important;
          }
          ._formInputFieldLabel_1ydxd_37{
              top: 21px !important;
          }
        }
      
      `;
  }

  style.textContent = commonStyles;
  shadowRoot.appendChild(style);
}

// Mutation Observer to watch for dynamically added Shopify Forms
const observer = new MutationObserver(() => {
  document.querySelectorAll("[data-forms-id]").forEach(formContainer => {
      const formId = formContainer.getAttribute("data-forms-id");
      const appEmbed = formContainer.querySelector("#app-embed");
      if (appEmbed && appEmbed.shadowRoot) {
          applyCustomFormStyles(appEmbed.shadowRoot, formId);
      }
  });
});

observer.observe(document.body, { childList: true, subtree: true });



// Newslatter sign up form css end

// faq header sticky
window.addEventListener("scroll", function () {
  const targetDiv = document.querySelector(".block__section-faq-accordion-links");
  if (targetDiv) {
    if (window.scrollY > 200) { 
      targetDiv.classList.add("faq_headersticky");
    } else {
      targetDiv.classList.remove("faq_headersticky");
    }
  } 
});

// Email Capture Popup


document.addEventListener("DOMContentLoaded", function () {
  let popupExpiryDays = 1; 
  let lastVisit = localStorage.getItem("newsletterPopupTimestamp");
  let now = new Date().getTime();
  let expiryTime = popupExpiryDays * 24 * 60 * 60 * 1000;

  if (!lastVisit || now - lastVisit > expiryTime) {
    localStorage.setItem("newsletterPopupTimestamp", now);
    localStorage.setItem("newsletterPopupShown", "true");

    setTimeout(() => {
      let popup = document.getElementById("newsletter-popup");
      let body = document.body;
      if(popup != null){
        popup.style.display = "flex"; 
        setTimeout(() => {
          popup.classList.add("show"); 
        }, 10);
        body.classList.add("overflow-hidden");
      }
    }, 2000); 
  }

  function closePopup() {
    let popup = document.getElementById("newsletter-popup");
    let body = document.body;

    popup.classList.remove("show");
    body.classList.remove("overflow-hidden");

    setTimeout(() => {
      popup.style.display = "none";
    }, 500); 
  }
  if(document.querySelector(".close-popup") != null){
    document.querySelector(".close-popup").addEventListener("click", closePopup);
  }
  if(document.getElementById("newsletter-popup") != null){
    document.getElementById("newsletter-popup").addEventListener("click", function (event) {
      if (event.target === this) {
        closePopup();
      }
    });
  }
});

// product page view details button scroll to tab

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".scroll-to-metafields").forEach(function(link) {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            const target = document.getElementById("metafield-section");
            if (target) {
                const offset = 80; 
                const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top: targetPosition, behavior: "smooth" });
            }
        });
    });
});



// Video page in the video popup







document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".block__main_videos_section--tab-name");
  const videoItems = document.querySelectorAll(".block__main-videos_section_item--wrapper");

  // Show all videos by default (for the first active tab)
  let activeFilter = document.querySelector(".block__main_videos_section--tab-name.nav-active")?.getAttribute("data-filter") || "all";
  
  videoItems.forEach(video => {
      if (activeFilter === "all" || video.getAttribute("data-category") === activeFilter) {
          video.style.display = "block";
      } else {
          video.style.display = "none";
      }
  });

  // Tab click event
  tabs.forEach(tab => {
      tab.addEventListener("click", function (event) {
          event.preventDefault(); 
          tabs.forEach(t => t.classList.remove("nav-active"));
          this.classList.add("nav-active");
          let filterCategory = this.getAttribute("data-filter");
          videoItems.forEach(video => {
              if (filterCategory === "all" || video.getAttribute("data-category") === filterCategory) {
                  video.style.display = "block"; 
              } else {
                  video.style.display = "none"; 
              }
          });
      });
  });
});

// trigger stock filter on collection page
// document.addEventListener("DOMContentLoaded", function () {
// if(document.querySelector('.collection-filter__item-stock-toggle') != null ){
//   const input_Desktop = document.querySelector('#Filter-Availability-2');
//   const input_mobile = document.querySelector('#Filter-Availability-mobile_2');

//     if (input_Desktop && !input_Desktop.checked) {
//       document.querySelector('label[for="Filter-Availability-2"]').click();
//     }

//     if (input_mobile && !input_mobile.checked) {
//       document.querySelector('label[for="Filter-Availability-mobile_2"]').click();
//     }
// }
// });

document.addEventListener("DOMContentLoaded", function () {
  let modal = document.getElementById("block_main_video-modal");
  let videoContainer = document.getElementById("block__main_videos-frame");
  let closeModal = document.querySelector(".close");

  function getVideoEmbedHTML(url) {
    const youtubeWatch = url.match(/(?:youtube\.com\/watch\?v=)([^\&\?]+)/);
    const youtubeShort = url.match(/youtu\.be\/([^\&\?]+)/);
    const youtubeEmbed = url.match(/youtube\.com\/embed\/([^\&\?]+)/);
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    const isMp4 = url.endsWith(".mp4");
    const isMp3 = url.endsWith(".mp3");

    if (youtubeWatch || youtubeShort || youtubeEmbed) {
      const id = (youtubeWatch && youtubeWatch[1]) || (youtubeShort && youtubeShort[1]) || (youtubeEmbed && youtubeEmbed[1]);
      return `<iframe width="100%" height="500" src="https://www.youtube.com/embed/${id}?autoplay=1" frameborder="0" allowfullscreen></iframe>`;
    } else if (vimeoMatch) {
      return `<iframe width="100%" height="500" src="https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1" frameborder="0" allowfullscreen></iframe>`;
    } else if (isMp4 || isMp3) {
      const type = isMp4 ? "video/mp4" : "audio/mpeg";
      const tag = isMp4 ? "video" : "audio";
      return `<${tag} controls autoplay style="width:100%; max-height:500px;"><source src="${url}" type="${type}">Your browser does not support the ${tag} tag.</${tag}>`;
    } else {
      return `<p style="color:red;">Unsupported video format: ${url}</p>`;
    }
  }

  document.querySelectorAll(".block__main_video-popup").forEach(link => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const videoSrc = this.getAttribute("data-video");
      const embedHTML = getVideoEmbedHTML(videoSrc);
      videoContainer.innerHTML = embedHTML;
      modal.style.display = "flex";
      document.body.style.overflow = "hidden";
    });
  });

  function closeVideoModal() {
    modal.style.display = "none";
    videoContainer.innerHTML = ""; // clear the embedded video
    document.body.style.overflow = ""; // restore scroll
  }

  if (closeModal) {
    closeModal.addEventListener("click", closeVideoModal);
  }

  if (modal) {
    modal.addEventListener("click", function (event) {
      if (!event.target.closest(".video-popup") && !event.target.closest(".block__main_video-popup")) {
        closeVideoModal();
      }
    });
  }
  
});


// custom blog page filter options

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".block_filter_custom-select-wrapper");

  if (wrapper) {
    const trigger = wrapper.querySelector(".custom-select-trigger");
    const options = wrapper.querySelector(".custom-options");
    const selectedOption = options.querySelector("li.selected");
    if (selectedOption) {
      trigger.textContent = selectedOption.textContent;
    }
    trigger.addEventListener("click", function (e) {
      e.stopPropagation();
      options.style.display = options.style.display === "block" ? "none" : "block";
    });

    options.querySelectorAll("li").forEach(function (item) {
      item.addEventListener("click", function () {
        const value = item.getAttribute("data-value");
        trigger.textContent = item.textContent;
        options.style.display = "none";
        window.location.href = value;
      });
    });

    document.addEventListener("click", function () {
      options.style.display = "none";
    });
  }
});

document.addEventListener('keydown', function (e) {
  const activeElement = document.activeElement;
  const isQtyInput = activeElement &&
    activeElement.tagName === 'INPUT' &&
    activeElement.type === 'number' &&
    activeElement.closest('.cart-drawer');

  if (isQtyInput && e.key === 'Enter') {
    e.preventDefault();
    e.stopPropagation();
  }
});

const inputs = document.querySelectorAll('.input-select-product');
let checked = Array.from(inputs).find(input => input.checked)?.value || '';
inputs.forEach(input => {
    input.addEventListener('click', function() {
        if (this.value === checked) {
            this.checked = false;
            checked = '';
        } else {
            this.checked = true;
            checked = this.value;
        }
    });
});

function membership_popup_open() {
  document.getElementById("membership-popup").classList.add("show-popup");
}

function membership_popup_close() {
  document.getElementById("membership-popup").classList.remove("show-popup");
}

// Redirect URL for the membership
document.querySelectorAll(".block__redirection-url").forEach(function (redirect) {
  redirect.addEventListener("click", function () {
    const value = redirect.getAttribute("href");
    window.location.href = value;
  });
});